import { render, staticRenderFns } from "./YandexFactory.vue?vue&type=template&id=8c799136&"
import script from "./YandexFactory.vue?vue&type=script&lang=js&"
export * from "./YandexFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports